import { AxiosRequestConfig } from 'axios';

const CREATE_ORDER_PATH = /^\/v1\/orders\/?(\?|$)/;

export const isCreateOrderRequest = (config: AxiosRequestConfig): boolean => {
    const url = config.url;
    const method = config.method?.toLowerCase();

    if (!url || method !== 'post') {
        return false;
    }

    return CREATE_ORDER_PATH.test(url);
};
